import { Alert } from "@livechat/design-system-react-components";

import Block from "components/layout/Block";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const NoSelectedTeamAlert = () => (
  <Block maxWidth="800px" data-testid="no-selected-team-alert">
    <Alert kind="error">
      The widget isn&apos;t connected to any team. Please select a team to continue receiving tickets from the widget.
    </Alert>
  </Block>
);
